import { render, staticRenderFns } from "./pay-by-link.vue?vue&type=template&id=5cfe4c6d&scoped=true"
import script from "./pay-by-link.vue?vue&type=script&lang=js"
export * from "./pay-by-link.vue?vue&type=script&lang=js"
import style0 from "./pay-by-link.vue?vue&type=style&index=0&id=5cfe4c6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe4c6d",
  null
  
)

export default component.exports